import qs from 'qs'
import AuthService from '@/packages/auth-service'
import store from '@/app/store'
import b2bApiClient from '@/shared/api/b2b-client'

export class MassPaymentsService {
  constructor() {
    this.client = b2bApiClient.getClient()
  }

  get _accessToken() {
    return store.state.auth.access_token || AuthService.getAccessToken()
  }

  get _headers() {
    return {
      'Content-Type': 'application/json',
      'x-access-token': this._accessToken,
    }
  }

  createMassPayment(formData) {
    return this.client.post('/payroll/mass-payments', formData, {
      headers: this._headers,
    })
  }

  getDetailMassPayment(id, params) {
    return this.client.client.get(`/payroll/mass-payments/${id}`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: this._headers,
    })
  }

  addUserMassPayment(id, formData) {
    return this.client.post(`/payroll/mass-payments/${id}/items`, formData, {
      headers: this._headers,
    })
  }

  deleteUserMassPayment(id, formData) {
    return this.client.delete(`/payroll/mass-payments/${id}/items`, {
      data: formData,
      headers: this._headers,
    })
  }

  getMassPayments(params) {
    return this.client.client.get(`/payroll/mass-payments`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'comma' })
      },
      headers: this._headers,
    })
  }

  deleteMassPayments(payload) {
    return this.client.client.delete(`/payroll/mass-payments`, {
      data: { mass_payment_ids: payload },
      headers: this._headers,
    })
  }

  updateMassPayment(id, data) {
    return this.client.client.patch(`/payroll/mass-payments/${id}`, data, {
      headers: this._headers,
    })
  }

  copyMassPayment(id) {
    return this.client.post(
      `/payroll/mass-payments/${id}/repeat`,
      {},
      {
        headers: this._headers,
      }
    )
  }

  uploadMassPaymentFile(id, file) {
    const formData = new FormData()
    formData.append('data', file)

    return this.client.client.patch(
      `/payroll/mass-payments/${id}/upload`,
      formData,
      {
        headers: {
          ...this._headers,
          'Content-Type': 'multipart/form-data',
        },
      }
    )
  }

  downloadExample(params) {
    return this.client.client.get(`/payroll/mass-payments/example`, {
      params,
      headers: this._headers,
    })
  }

  downloadTableRow(id, params) {
    return this.client.client.get(`/payroll/mass-payments/${id}/download`, {
      params,
      headers: this._headers,
    })
  }

  payItems(id, formData) {
    return this.client.post(
      `/payroll/mass-payments/${id}/items/pay`,
      formData,
      {
        headers: this._headers,
      }
    )
  }

  getPaymentInfo(id, formData) {
    return this.client.post(
      `/payroll/mass-payments/${id}/items/required`,
      formData,
      {
        headers: this._headers,
      }
    )
  }

  reInviteUser(formData) {
    return this.client.post('/users/invite', formData, {
      headers: this._headers,
    })
  }

  updateUser(id, itemId, formData) {
    return this.client.patch(
      `/payroll/mass-payments/${id}/items/${itemId}`,
      formData,
      {
        headers: this._headers,
      }
    )
  }

  getTermsStatus() {
    return this.client.client.get('/payroll/terms/status', {
      headers: this._headers,
    })
  }

  acceptTerms() {
    return this.client.post(
      '/payroll/terms/accept',
      {},
      {
        headers: this._headers,
      }
    )
  }

  getRecipients(params) {
    return this.client.client.get('/payroll/recipients', {
      params,
      paramsSerializer: (requestParams) => {
        return qs.stringify(requestParams, { arrayFormat: 'comma' })
      },
      headers: this._headers,
    })
  }

  createRecipient(data) {
    return this.client.post('/payroll/recipients', data, {
      headers: this._headers,
    })
  }

  updateRecipient(id, data) {
    return this.client.client.patch(`/payroll/recipients/${id}`, data, {
      headers: this._headers,
    })
  }

  deleteRecipients(recipientIds) {
    return this.client.client.delete('/payroll/recipients', {
      data: { recipient_ids: recipientIds },
      headers: this._headers,
    })
  }
}

export const massPaymentsService = new MassPaymentsService()
export default massPaymentsService
